export default __webpack_public_path__ + "static/media/doc-thank.45c22da3.svg";